import { QuestionnaireRequest } from 'src/app/core/api/questionnaire-request.service';

export class QuestionnaireRequestData {
  data: QuestionnaireRequest;

  constructor() {}
}
